// Conceptos de movimientos con sus etiquetas
export const MOVEMENT_CONCEPTS = {
  SALES: 'Acreditación por ventas',
  ADJUSTMENT_DEBIT: 'Ajuste de débito',
  ADJUSTMENT_CREDIT: 'Ajuste de crédito',
  DEPOSIT: 'Ingreso de dinero',
  ATM: 'Retiro manual',
  PURCHASE: 'Compra',
  REFUND_ATM: 'Reversa retiro',
  REFUND_PURCHASE: 'Reversa compra',
  REVERSAL: 'Reversa',
  RECHARGE: 'Recarga',
  SERVICE: 'Pago de servicio',
  CASHIN: 'Ingreso de dinero',
  CASHIN_REVERSAL: 'Reversa ingreso',
  CASHOUT: 'Retiro automático',
  CASHOUT_REVERSAL: 'Reversa retiro automático',
  TAX_CREDIT: 'Impuesto crédito',
  TAX_DEBIT: 'Impuesto débito',
  TAX_DEBIT_REVERSAL: 'Reversa impuesto débito',
  TAX_CREDIT_REVERSAL: 'Reversa impuesto crédito',
  PURCHASE_QR: 'Compra QR',
  PURCHASE_QR_CHARGEBACK: 'Contracargo compra QR',
};

// Configuración de paginación
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_DAYS_VIEW = 30;
export const MAX_DAYS_DOWNLOAD = 90;

// Tipos de entrada
export const ENTRY_TYPES = {
  credit: 'Crédito',
  debit: 'Débito',
};

